/* eslint-disable react/no-unused-prop-types */
// External Dependencies
import PropTypes from 'prop-types';
import React from 'react';
import {
  faintBlack,
  grey50,
  lightBlack,
  minBlack,
} from 'material-ui/styles/colors';

// Internal Dependencies

// Local Variables
const propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.node,
  hasExtraTitleMargin: PropTypes.bool,
  hideShadow: PropTypes.bool,
  icon: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.array,
  ]),
  iconColor: PropTypes.string,
  isCentered: PropTypes.bool,
  style: PropTypes.shape({}),
  title: PropTypes.node,
};

const defaultProps = {
  backgroundColor: '',
  children: '',
  hasExtraTitleMargin: false,
  hideShadow: false,
  icon: null,
  iconColor: faintBlack,
  isCentered: true,
  style: null,
  title: '',
};

const iconStyles = {
  height: 128,
  width: 128,
};

const textContainerStyles = {
  textAlign: 'center',
};

const titleStyles = {
  fontSize: 16,
  margin: '32px 0',
};

const rootStyles = {
  backgroundColor: grey50,
  boxShadow: `inset 0px 8px 6px -8px ${minBlack}`,
  color: lightBlack,
  display: 'flex',
  flex: 1,
  fontSize: 14,
  justifyContent: 'center',
  padding: '24px 16px',
  height: 420,
};

// Component Definition
const EmptyState = (props) => {
  const {
    backgroundColor,
    children,
    hideShadow,
    icon: Icon,
    iconColor,
    isCentered,
    title,
    // Styles
    style,
  } = props;

  const styles = style || isCentered || hideShadow || backgroundColor
    ? {
      ...rootStyles,
      backgroundColor: backgroundColor || grey50,
      boxShadow: hideShadow ? null : `inset 0px 8px 6px -8px ${minBlack}`,
      justifyContent: isCentered ? 'center' : null,
      ...style,
    }
    : rootStyles;

  let iconElement = Icon && <Icon color={iconColor} style={iconStyles} />;

  if (Icon && Object.prototype.toString.call(Icon) === '[object Array]') {
    iconElement = Icon.map(
      CurrentIcon => <CurrentIcon color={iconColor} style={iconStyles} />,
    );
  }

  const titleElement = title && (
    <div style={titleStyles}>{title}</div>
  );

  return (
    <div style={styles}>
      <div style={isCentered && textContainerStyles}>
        {iconElement}
        {titleElement}
        {children}
      </div>
    </div>
  );
};

EmptyState.propTypes = propTypes;
EmptyState.defaultProps = defaultProps;
export default EmptyState;



/** WEBPACK FOOTER **
 ** ./src/shared/empty-state/index.js
 **/